import { FILTER_KEY_MAP, OS_PREFIX_MAP } from './constants';

/**
 * Validate filter value from URL
 *
 * @param  {string} key
 * @param  {[]} value
 * @param  {[]} validItems
 * @return {boolean}
 */
export const validateFilter = (key, value, validItems) => (
  value.every((item) => validItems.includes(item))
);

/**
 * Prepare list of OS values - os + os_version
 * @param {object} payload
 * @returns {[]}
 */
export const prepareOSList = (payload) => (
  payload?.versions?.length ?
    payload.versions.map(({ value }) => `${OS_PREFIX_MAP[payload.value]} ${value}`) :
    []
);

/**
 * Prepare filter values
 *
 * @param {object} payload
 * @returns {object}
 */
export const parseFilters = (payload = {}) => (
  Object.entries(payload).reduce((acc, [key, items]) => {
    const name = FILTER_KEY_MAP[key] || key;
    if (name === FILTER_KEY_MAP.os) {
      const [android, ios] = items;
      acc[name] = [
        ...(prepareOSList(android)),
        ...(prepareOSList(ios)),
      ];
    } else {
      acc[name] = items.map(({ value }) => value);
    }
    return acc;
  }, {})
);

/**
 * Convert selected filter to queryParams
 *
 * @param {string} key
 * @param {[]} value
 * @returns {object}
 */
export const convertFilterToQueryParam = (key, value) => {
  switch (key) {
    case 'device':
      return { device: value };
    case 'build':
      return { build_name: value };
    case 'status':
      return { status: value.map((status) => status.toLowerCase()) };
    case 'owner':
      return { owner_id: value };
    case 'team':
      return { team_id: value };
    case 'os': {
      const osMap = {
        Android: 'ANDROID',
        Ios: 'IOS',
        ' ': '__',
      };
      return {
        os: value.map((item) => item.replace(/Android|Ios| /g, (matched) => osMap[matched])),
      };
    }
    default:
      return {};
  }
};
